// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2022project/q3/2022perceive/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

const getCountyList = (page: any) => {
  return http.get(`${urlPrefix}county-list&page=${page}`);
};

const getList = (page: number, countyId: any, keyword?: string) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
      countyId,
      search: keyword,
    },
  });
};

const getListCountyMessage = (countyId: any) => {
  return http.get(`${urlPrefix}vote-list-countyMessage&countyId=${countyId}`);
};

const getListRank = (page: number, countyId: number) => {
  return http.get(`${urlPrefix}vote-list-rank`, {
    params: {
      page,
      countyId,
    },
  });
};

const getDetail = (id: any) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getRankAll = (page: number) => {
  return http.get(`${urlPrefix}rankAll&page=${page}`);
};

const getRule = () => {
  return http.get(`${urlPrefix}rules`);
};

// 获取微信js sdk
function wxSdkInfo(jssdkurl: any) {
  return http.get('/vote/public/controller.php?enews=jssdk&token=cq_zhbf', {
    params: { ...jssdkurl },
  });
}

export {
  getBaseInfo,
  getNews,
  getCountyList,
  getList,
  getListRank,
  getDetail,
  getRankAll,
  getListCountyMessage,
  getRule,
  wxSdkInfo,
};
